import { useEffect } from 'react';

// 定义严格的 ModeType 字符串字面量联合类型，仅允许指定的三个值
export type ModeType = 'home' | 'quanwu' | 'hard';

// Hook 入参：必传 mode + 可选目标源（生产环境必须指定具体域名）
interface UseMouseUpPostMessageProps {
  targetOrigin?: string;
}

/**
 * 监听鼠标 mouseup 事件，向父页面发送固定结构 postMessage 的 React Hook
 * @param mode 必传，ModeType 类型，映射到消息体 data.type
 * @param options 可选，配置 targetOrigin，生产环境务必指定具体父域名
 */
const useMouseUpPostMessage = (
  mode: ModeType,
  { targetOrigin = '*' }: UseMouseUpPostMessageProps = {}
) => {
  useEffect(() => {
    // 定义 mouseup 事件处理函数，构建固定结构的 postMessage 消息
    const handleMouseUp = () => {
      // 固定格式的消息体，仅 data.type 由 mode 动态决定
      const postMessageData = {
        origin: 'uiapi.materialUiplugin',
        data: {
          action: 'iframeMouseUp',
          type: mode, // 映射传入的 ModeType 参数
        },
      };
      // 向父页面发送固定结构消息
      window.parent.postMessage(postMessageData, targetOrigin);
    };

    // 挂载全局 mouseup 事件监听
    document.addEventListener('mouseup', handleMouseUp);

    // 销毁：组件卸载/依赖更新时移除监听，避免内存泄漏
    return () => {
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [mode, targetOrigin]); // 依赖项：mode/targetOrigin变化时重新绑定事件
};

export {
  useMouseUpPostMessage
}
